import axios from 'axios';

import { API_BASE_URL } from 'src/common/constants';

export default class OrdersService {
    static instance;
    resource = `${API_BASE_URL}/subscription/orders`;

    static getInstance() {
        if (!OrdersService.instance) {
            OrdersService.instance = new OrdersService();
        }

        return OrdersService.instance;
    }

    async fetchOrders(params = {}) {
        const response = await axios.get(
            `${this.resource}`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchOrderDetails(orderId, params = {}) {
        const response = await axios.get(
            `${this.resource}/${orderId}`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchOrderSubscriptions(orderId, params = {}) {
        const response = await axios.get(
            `${this.resource}/${orderId}/subscriptions`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async getOrderInvoiceLinkUrl(orderId, params = {}) {
        const response = await axios.get(
            `${this.resource}/${orderId}/invoice`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }
}
